import { useLayoutEffect, useState } from 'react';

import { nodemapToTree } from '../../utils/nodemap-to-tree';
import { PositionedTree, Tree } from './types';
import { X_GAP, Y_GAP } from './use-mindmap';
import { Data } from './use-mindmap-data';

const { BoundingBox, Layout } = require('non-layered-tidy-tree-layout');

type BoundingBox = { left: number; right: number; top: number; bottom: number };

export interface Positioning {
  positionedTree: PositionedTree | undefined;
  boundingBox: BoundingBox | undefined;
}

type UsePositioning = { data: Data };

export const useMindmapPositioning = ({ data: { nodeMap } }: UsePositioning): Positioning => {
  const [positionedTree, setPositionedTree] = useState<PositionedTree>();
  const [boundingBox, setBoundingBox] = useState<BoundingBox>();

  // calculate new layout before re-render
  useLayoutEffect(() => {
    // convert flat node map to tree
    let tree: Tree | undefined;
    if (nodeMap && (tree = nodemapToTree(nodeMap))) {
      // recalculate positioning
      const layout = new Layout(new BoundingBox(X_GAP, Y_GAP));
      const { result, boundingBox } = layout.layout(tree);
      setBoundingBox(boundingBox);
      setPositionedTree(result);
    }
  }, [nodeMap]);

  return { positionedTree, boundingBox };
};
